import React, { useState, useEffect } from "react";
import { Getledgergroups, AddGroup } from "../store/slices/ledger";
import { useDispatch } from "react-redux";
import Loader from "./Loader";
import {toast } from 'react-hot-toast';
const GroupPopUp = ({ show, onClose, onSubmit }) => {
  const dispatch = useDispatch();
  const [selectedOption, setSelectedOption] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [ledgerGroups, setLedgerGroups] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchLedgerGroups = async () => {
      try {
        const data = await dispatch(Getledgergroups()).unwrap();

        // Filter out default groups (is_default == 1) while preserving non-default children
        const isDefault = (val) => Number(val) === 1 || val === true || val === '1';
        const filterOutDefaultGroups = (groups = []) => {
          const result = [];
          (groups || []).forEach((grp) => {
            const filteredChildren = grp?.children ? filterOutDefaultGroups(grp.children) : [];
            if (!isDefault(grp?.is_default)) {
              result.push({ ...grp, children: filteredChildren });
            } else {
              // Skip default group, promote its non-default children
              result.push(...filteredChildren);
            }
          });
          return result;
        };

        const groupsArray = Array.isArray(data) ? data : (Array.isArray(data?.data) ? data.data : []);
        const filtered = filterOutDefaultGroups(groupsArray);
        setLedgerGroups(filtered);
      } catch (error) {
        console.error("Error fetching ledger groups:", error.message || error);
      }
    };
    fetchLedgerGroups();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedOption(value);
  };

  const handleSubmit = () => {
    if (selectedOption && inputValue.trim()) {
      const groupName = inputValue.trim();
      const parentGroupId = selectedOption;
      const profileId = 1039; // Replace with dynamic profile ID if needed

      const payload = {
        profile_id: profileId,
        group_name: groupName,
        parent_group_id: parentGroupId,
      };
      console.log("Payload to be sent:", payload);
      setIsLoading(true);
      dispatch(AddGroup(payload))
        .unwrap()
        .then(() => {
          setIsLoading(false);
          toast.success("Group added successfully!");
          onSubmit();
          onClose(); // Close the modal after successful submission
        })
        .catch((error) => {
          setIsLoading(false);
          alert("Failed to add group: " + error.message);
        });
    } else {
      alert("Please fill in both fields.");
    }
  };

  const findGroupNameById = (groups, id) => {
    for (let group of groups) {
      if (group.id === id) return group.group_name;
      if (group.children) {
        const found = findGroupNameById(group.children, id);
        if (found) return found;
      }
    }
    return null;
  };

  const renderOptions = (groups, level = 0) => {
    return groups.map((group) => (
      <React.Fragment key={group.id}>
        <option value={group.id}>
          {"\u00A0".repeat(level * 4)} {group.group_name}
        </option>
        {group.children?.length > 0 && renderOptions(group.children, level + 1)}
      </React.Fragment>
    ));
  };

  if (!show) return null;

  return (
    <>
      {isLoading && <Loader />}
      <div
        className="modal-backdrop"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0,0,0,0.5)",
          zIndex: 1050,
        }}
      >
        <div
          className="card p-4"
          style={{ maxWidth: "500px", margin: "10% auto", background: "white" }}
        >
          <h5 className="mb-4">Add Group</h5>

          <div className="mb-3">
            <label className="form-label">Parent Group</label>
            <select
              name="group_name"
              className="form-control"
              value={selectedOption}
              onChange={handleInputChange}
            >
              <option value="">Select</option>
              {renderOptions(ledgerGroups)}
            </select>
          </div>

          <div className="mb-3">
            <label className="form-label">Group Name</label>
            <input
              type="text"
              className="form-control"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              placeholder="Type Group Name"
            />
          </div>

          <div
            className="text-end d-flex justify-content-end gap-2"
            style={{ gap: "10px" }}
          >
            <button className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button className="btn ripple btn-default" onClick={handleSubmit}>
              Submit
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default GroupPopUp;
